import React, { useState, useRef, useEffect }  from 'react';
import { Chart, registerables } from 'chart.js';
import hexToRgba from 'hex-to-rgba';
import { getTooltip } from '../../model/Chart';
Chart.register(...registerables);

const LineChart = ({ datasets, labels, height, displayAxes }: Props) => {
  const chartRef = useRef();
  const [chart, setChart] = useState(null);

  useEffect(() => {
    if(chart) {
      chart.destroy();
    }
    for(let dataset of datasets) {
      const color = hexToRgba(dataset.color || '#1ACBE6', 1);
      const lastColor = hexToRgba(dataset.color || '#1ACBE6', 0);
      const gradient = chartRef.current.getContext('2d').createLinearGradient(0, 0, 0, height ? height / 1.3 : 200);
      gradient.addColorStop(0, color);   
      gradient.addColorStop(1, lastColor);
      dataset.pointRadius = 10;
      dataset.pointBorderWidth = 0;
      dataset.pointBackgroundColor = lastColor,
      dataset.pointHoverRadius = 10;
      dataset.pointHoverBorderWidth = 0;
      dataset.pointHoverBackgroundColor = lastColor,
      dataset.cubicInterpolationMode = 'monotone';
      dataset.borderColor = color;
      dataset.backgroundColor = gradient;
    }
    const c = new Chart(chartRef.current, {
      type: 'line',
      data: {
        labels: labels,
        datasets: datasets
      },
      options: {
        color: '#6F6B7D',
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        plugins: {
          legend: {
            align: 'start',
            labels: {
              usePointStyle: true,
              boxWidth: 7
            }
          },
          tooltip: getTooltip()
        },
        scales: {
          x: {
            display: displayAxes,
            min: 0,
            grid: {
              display: true,
              color: '#F2F3F7'
            },
            ticks: {
              color: '#6F6B7D'
            }
          },
          y: {
            display: displayAxes,
            grid: {
              display: true,
              color: '#F2F3F7'
            },
            ticks: {
              color: '#6F6B7D'
            }
          }
        },
      }
    });
    setChart(c);
  }, [ datasets, labels ]);

  const style = {};
  if(height) {
    style.height = height;
  }
  return (
    <div style={style}>
      <canvas ref={chartRef}></canvas>
    </div>
  );
}


interface Props {
  datasets: ChartDataset[],
  labels: string[],
  height: number,
  displayAxes: boolean
}

export { LineChart };